"use client"

import React from 'react'
import Image from 'next/image'

const RecognizedBy = () => {

   return (
      <section className="bg-[#020617] pt-0 pb-0 relative overflow-hidden">
         {/* Top Gradient Flow from Hero - Tighter & Stops at/after text */}




         {/* Full-width Recognition Strip */}
         <div className="w-full py-12 bg-white/[0.02] border-y border-white/[0.05]">
            <div className="max-w-[1800px] mx-auto px-6 lg:px-8">
               <div className="flex flex-wrap justify-center items-center gap-12 md:gap-20 lg:gap-32">
                  {/* Samsung */}
                  <div className="flex items-center justify-center opacity-60 grayscale hover:opacity-100 hover:grayscale transition-all duration-300">
                     <Image src="/Samsung-Logo-2-500x281.png" alt="Samsung" width={130} height={75} className="object-contain" />
                  </div>
                  {/* Paytm */}
                  <div className="flex items-center justify-center opacity-60 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-300">
                     <Image src="/images/Paytm.png" alt="Paytm" width={120} height={65} className="object-contain" />
                  </div>

                  {/* Gartner */}
                  <div className="flex items-center justify-center opacity-80 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-300">
                     <Image src="/images/Gartner.png" alt="Gartner" width={120} height={65} className="object-contain" />
                  </div>

                  {/* LG */}
                  <div className="flex items-center justify-center opacity-60 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-300">
                     <Image src="/images/LG logo.png" alt="LG" width={65} height={65} className="object-contain" />
                  </div>

                  {/* Maven */}
                  <div className="flex items-center justify-center opacity-60 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-300">
                     <Image src="/images/Maven.png" alt="Maven" width={120} height={65} className="object-contain" />
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default RecognizedBy
